import useId from '../utils/useId';
import * as React from 'react';
export const slashSvg = React.forwardRef(function slashSvgInner(props, ref) {
  const baseId = useId();
  const id_0 = baseId + '_0';
  const id_1 = baseId + '_1';
  const id_2 = baseId + '_2';
  const id_3 = baseId + '_3';
  const id_4 = baseId + '_4';
  const id_5 = baseId + '_5';
  const id_6 = baseId + '_6';
  const id_7 = baseId + '_7';
  const id_8 = baseId + '_8';
  const id_9 = baseId + '_9';
  const id_10 = baseId + '_10';
  const id_11 = baseId + '_11';
  const id_12 = baseId + '_12';
  const id_13 = baseId + '_13';
  const id_14 = baseId + '_14';
  const id_15 = baseId + '_15';
  const id_16 = baseId + '_16';
  const id_17 = baseId + '_17';
  const id_18 = baseId + '_18';
  const id_19 = baseId + '_19';
  const id_20 = baseId + '_20';
  const id_21 = baseId + '_21';
  const id_22 = baseId + '_22';
  const id_23 = baseId + '_23';
  const id_24 = baseId + '_24';
  const id_25 = baseId + '_25';
  const id_26 = baseId + '_26';
  const id_27 = baseId + '_27';
  const id_28 = baseId + '_28';
  const id_29 = baseId + '_29';
  const id_30 = baseId + '_30';
  const id_31 = baseId + '_31';
  const id_32 = baseId + '_32';
  const id_33 = baseId + '_33';
  const id_34 = baseId + '_34';
  const id_35 = baseId + '_35';
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#F5F6F8',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement(
      'g',
      null,
      /*#__PURE__*/ React.createElement('rect', {
        x: -484,
        y: -2174,
        width: 712,
        height: 2786,
        rx: 32,
        fill: '#fff',
      }),
      /*#__PURE__*/ React.createElement(
        'g',
        null,
        /*#__PURE__*/ React.createElement(
          'g',
          null,
          /*#__PURE__*/ React.createElement(
            'g',
            null,
            /*#__PURE__*/ React.createElement(
              'mask',
              {
                id: `bi_slash__a_${id_0}`,
                style: {
                  maskType: 'luminance',
                },
                maskUnits: 'userSpaceOnUse',
                x: 0,
                y: 0,
                width: 32,
                height: 32,
              },
              /*#__PURE__*/ React.createElement(
                'g',
                null,
                /*#__PURE__*/ React.createElement('path', {
                  d: 'M32 0H0v32h32V0Z',
                  fill: '#fff',
                }),
              ),
            ),
            /*#__PURE__*/ React.createElement(
              'g',
              {
                mask: `url(#bi_slash__a_${id_0})`,
              },
              /*#__PURE__*/ React.createElement(
                'g',
                null,
                /*#__PURE__*/ React.createElement('path', {
                  d: 'M32 0H0v32h32V0Z',
                  fill: '#000',
                }),
                /*#__PURE__*/ React.createElement(
                  'g',
                  {
                    opacity: 0.4,
                    filter: `url(#bi_slash__b_${id_1})`,
                  },
                  /*#__PURE__*/ React.createElement('path', {
                    d: 'M13.377 10.703c-3.58 3.855-9.113 4.537-12.359 1.523-3.246-3.014-2.976-8.582.603-12.437 3.58-3.855 4.992-.1 8.238 2.915 3.247 3.014 7.097 4.144 3.518 8Z',
                    fill: '#373B49',
                    fillOpacity: 0.6,
                  }),
                ),
                /*#__PURE__*/ React.createElement(
                  'g',
                  {
                    opacity: 0.6,
                    filter: `url(#bi_slash__c_${id_2})`,
                  },
                  /*#__PURE__*/ React.createElement('path', {
                    d: 'M25.402 21.405c2.671 0 4.837-1.402 4.837-3.13 0-1.73-2.166-3.131-4.837-3.131-2.67 0-4.836 1.401-4.836 3.13 0 1.73 2.166 3.131 4.837 3.131Z',
                    fill: '#CD8939',
                  }),
                ),
                /*#__PURE__*/ React.createElement(
                  'g',
                  {
                    opacity: 0.6,
                    filter: `url(#bi_slash__d_${id_3})`,
                  },
                  /*#__PURE__*/ React.createElement('path', {
                    d: 'M20.476 21.694c1.385 0 2.508-1.77 2.508-3.952 0-2.183-1.123-3.952-2.508-3.952s-2.508 1.77-2.508 3.952c0 2.183 1.123 3.952 2.508 3.952Z',
                    fill: '#C6A288',
                  }),
                ),
                /*#__PURE__*/ React.createElement(
                  'g',
                  {
                    filter: `url(#bi_slash__e_${id_4})`,
                  },
                  /*#__PURE__*/ React.createElement('path', {
                    d: 'M19.646 19.435c.606 0 1.097-.885 1.097-1.976 0-1.09-.491-1.975-1.097-1.975s-1.097.884-1.097 1.975c0 1.091.491 1.976 1.097 1.976Z',
                    fill: '#E0AF49',
                    fillOpacity: 0.9,
                  }),
                ),
                /*#__PURE__*/ React.createElement(
                  'g',
                  {
                    opacity: 0.4,
                    filter: `url(#bi_slash__f_${id_5})`,
                  },
                  /*#__PURE__*/ React.createElement('path', {
                    d: 'M10.774 20.098c-7.139 7.689-18.175 9.049-24.65 3.037-6.475-6.012-5.937-17.118 1.203-24.808 7.139-7.689 9.957-.197 16.432 5.815 6.475 6.011 14.154 8.267 7.015 15.956Z',
                    fill: '#373B49',
                  }),
                ),
                /*#__PURE__*/ React.createElement(
                  'g',
                  {
                    style: {
                      mixBlendMode: 'overlay',
                    },
                    opacity: 0.4,
                    filter: `url(#bi_slash__g_${id_6})`,
                  },
                  /*#__PURE__*/ React.createElement('path', {
                    d: 'M6.155 18.324C5.62 22.057-.77 26.241-5.932 26.241c-5.163 0-.534-3.544-.534-7.917 0-4.372-4.629-12.837.534-12.837 10.55.34 12.087 8.465 12.087 12.837Z',
                    fill: '#fff',
                  }),
                ),
                /*#__PURE__*/ React.createElement(
                  'g',
                  {
                    style: {
                      mixBlendMode: 'overlay',
                    },
                    opacity: 0.9,
                    filter: `url(#bi_slash__h_${id_7})`,
                  },
                  /*#__PURE__*/ React.createElement('path', {
                    d: 'M1.9 3.381c-.836 3.732-10.83 7.917-18.906 7.917-8.077 0-.836-3.545-.836-7.917 0-4.373-7.24-12.837.836-12.837C-.503-9.117 1.9-.992 1.9 3.38Z',
                    fill: '#fff',
                  }),
                ),
                /*#__PURE__*/ React.createElement(
                  'g',
                  {
                    opacity: 0.4,
                    filter: `url(#bi_slash__i_${id_8})`,
                  },
                  /*#__PURE__*/ React.createElement('path', {
                    d: 'M58.182 31.713c-7.14 7.689-18.176 9.049-24.65 3.037-6.476-6.012-5.937-17.119 1.202-24.808 7.14-7.689 9.957-.197 16.432 5.814 6.475 6.012 14.154 8.267 7.016 15.957Z',
                    fill: '#373B49',
                  }),
                ),
                /*#__PURE__*/ React.createElement('g', {
                  style: {
                    mixBlendMode: 'overlay',
                  },
                  opacity: 0.4,
                  filter: `url(#bi_slash__j_${id_9})`,
                }),
                /*#__PURE__*/ React.createElement(
                  'g',
                  {
                    style: {
                      mixBlendMode: 'overlay',
                    },
                    opacity: 0.9,
                    filter: `url(#bi_slash__k_${id_10})`,
                  },
                  /*#__PURE__*/ React.createElement('path', {
                    d: 'M49.307 14.996c-.835 3.732-10.83 7.917-18.906 7.917-8.077 0-.836-3.545-.836-7.917 0-4.373-7.24-12.837.836-12.837 16.504.339 18.906 8.464 18.906 12.837Z',
                    fill: '#fff',
                  }),
                ),
                /*#__PURE__*/ React.createElement(
                  'g',
                  {
                    style: {
                      mixBlendMode: 'overlay',
                    },
                    opacity: 0.9,
                    filter: `url(#bi_slash__l_${id_11})`,
                  },
                  /*#__PURE__*/ React.createElement('path', {
                    d: 'M19.14 21.827c.707-3.154 9.153-6.69 15.978-6.69 6.826 0 .706 2.995.706 6.69 0 3.695 6.12 10.849-.706 10.849-13.947-.287-15.977-7.154-15.977-10.849Z',
                    fill: '#fff',
                  }),
                ),
                /*#__PURE__*/ React.createElement(
                  'g',
                  {
                    filter: `url(#bi_slash__m_${id_12})`,
                  },
                  /*#__PURE__*/ React.createElement('path', {
                    fillRule: 'evenodd',
                    clipRule: 'evenodd',
                    d: 'M11.637 18.267V15.59l-.005-.333.014-3.765a8.798 8.798 0 0 1-1.902.363v.068c.276.13.458.265.541.398.08.13.08.415.08.84v4.587s0 .014.003.02v.122h-.003s0 .022.003.03c0 .248 0 .5.003.748 0 .109.088.194.196.194h1.068l.194-.002a7.08 7.08 0 0 1 .39.002l.01-.058-.021-.005c-.016-.005-.032-.01-.049-.011-.378-.05-.5-.161-.527-.518l.005-.003ZM7.65 13.503c-.042.005-.1.038-.11.074-.009.03.016.1.057.114.08.027.326.05.326.05.058.008.113.01.157.01.075 0 .141.003.203.006.162.006.295.012.479-.036.63-.16.759-.977.535-1.454-.204-.437-.618-.548-1.043-.568a22.277 22.277 0 0 0-1.86 0c-.22.009-.458.085-.654.189-.445.232-.56.65-.552 1.113.005.398.11.486.513.428l.11-.015c.18-.026.36-.052.542-.061.13-.006.234.055.231.216-.005.152-.093.218-.234.212a3.298 3.298 0 0 1-.265-.025 6.606 6.606 0 0 0-.133-.016 5.68 5.68 0 0 1-.152-.018 2.678 2.678 0 0 0-.336-.028c-.21 0-.287.12-.24.325.077.322.309.496.596.608.342.132.642.24.956.352.168.06.34.121.523.188.07.025.238.112.318.156 0 0 .165.109.262.175.1.068.116.231.118.349l.001.428c.003.6.005 1.202-.03 1.8-.042.678-.467.73-.95.65-.177-.027-.274-.142-.329-.289a.768.768 0 0 1-.044-.237l-.039-1.545a3.129 3.129 0 0 1-.022-.166 1.33 1.33 0 0 0-.074-.355 1.046 1.046 0 0 0-.301-.43 1.064 1.064 0 0 0-.497-.192 1.349 1.349 0 0 0-.971.232c.336.046.403.284.436.54.012.086.012.174.013.262v1.144c.006.753.495 1.143 1.154 1.184.624.035 1.253.035 1.88 0 .585-.033 1.087-.336 1.145-.98.047-.531.034-1.069.021-1.603a102.29 102.29 0 0 1-.004-.176c-.006-.295-.19-.505-.467-.611a11.3 11.3 0 0 0-.844-.284l-.483-.15a7.995 7.995 0 0 0-.22-.092 3.83 3.83 0 0 1-.44-.203c-.218-.122-.323-.332-.35-.58-.017-.134.01-.205.168-.23.273-.044.37-.17.359-.412-.008-.216-.094-.32-.329-.363-.154-.027-.232-.09-.204-.25.013-.083.023-.166.032-.249.02-.179.041-.358.098-.524.096-.287.375-.382.764-.33.274.038.453.194.48.486.028.278.025.562.009.84-.011.177-.1.32-.31.344v-.003Zm19.052 4.766c.025.358.14.47.496.519l-.002.005c.014.002.027.006.04.01a.456.456 0 0 0 .023.006l-.008.058c-.121-.006-.244-.004-.367-.002l-.185.002h-1.01a.188.188 0 0 1-.185-.194c0-.248 0-.5-.006-.748v-.739l.008-1.282v-.055c0-.783-.267-1.173-.808-1.173-.417 0-.795.237-1.131.715v2.88c.027.358.148.47.527.52a.287.287 0 0 1 .048.01l.02.006-.008.057a6.98 6.98 0 0 0-.39-.002l-.195.002h-1.068a.194.194 0 0 1-.196-.194c-.003-.248-.003-.499-.003-.747-.002-.009-.002-.03-.002-.03h.002v-.123c-.002-.006-.002-.02-.002-.02v-4.545c0-.382 0-.655-.05-.81a.336.336 0 0 0-.033-.071c-.083-.134-.265-.268-.541-.399v-.068l.036-.003.036-.002a8.746 8.746 0 0 0 1.832-.358l-.013 3.572c.469-.685 1.048-1.026 1.738-1.026.373 0 .701.115.977.347.279.231.42.586.42 1.072v2.81Zm-5.234-3.595-.002-.047a1.166 1.166 0 0 0-.007-.095c-.058-.529-.33-.876-.767-.944a7.31 7.31 0 0 0-2.313.009c-.361.06-.665.261-.731.633a4.585 4.585 0 0 0-.058 1.115c.028.396.315.603.693.674.16.03.322.05.492.07l.245.031c1.175.123 1.131.734 1.131.734a20.02 20.02 0 0 1 0 1.63c-.008.258-.176.392-.441.411a2.405 2.405 0 0 1-.147.006c-.543.005-.687-.123-.709-.666-.008-.215-.008-.43-.007-.645 0-.144.001-.287-.001-.43-.003-.287-.1-.42-.334-.497a.462.462 0 0 0-.392.052l-.69.453c-.074.05-.145.105-.216.162l-.104.081.016.05c.027 0 .053.004.08.007.055.006.11.012.163.009.133-.006.182.049.188.177.004.125.023.248.042.37l.013.09c.06.424.284.705.707.784.772.142 1.553.12 2.332.02.422-.055.704-.31.756-.732.05-.401.064-.808.055-1.212-.008-.36-.198-.635-.56-.73a5.3 5.3 0 0 0-.633-.116 13.088 13.088 0 0 1-.272-.04l-.483-.08c-.4-.079-.516-.294-.516-.294-.064-.09-.125-.208-.125-.311 0-.48.014-.963.039-1.444.008-.188.135-.31.326-.33a2.22 2.22 0 0 1 .554-.005c.246.035.35.166.37.415.017.226.028.453.025.679-.003.235.05.434.224.573.105.082.24.114.372.09l.93-.161v-.052c-.233-.06-.236-.224-.238-.388-.001-.035-.002-.071-.005-.106h-.002Zm-4.945 3.024c0 .171 0 .346.008.52l.006.006c.019.398.135.521.53.57a.287.287 0 0 1 .048.011l.02.006-.008.057a6.06 6.06 0 0 0-.357-.002c-.515.005-1.029.011-1.412-.503l-.01.017c-.047.078-.08.134-.117.19-.149.224-.348.374-.626.374h-.16c-.3.002-.602.003-.897-.03-.597-.065-.909-.404-.936-1.026a27.63 27.63 0 0 1-.006-1.656.84.84 0 0 1 .715-.818c.215-.035.436-.035.657-.034.076 0 .153 0 .23-.002l1.015.014v-.808c0-.125 0-.25-.008-.376-.036-.56-.285-.75-.85-.658-.31.05-.437.18-.453.491-.008.088-.008.172-.008.257a.11.11 0 0 1 .002.03.848.848 0 0 1 .006.087l.003.044c.002.03.003.063.003.095.002.15.003.299.217.355v.049l-.623.11c-.527.119-.596.108-.705.092h-.002c-.138-.022-.207-.08-.218-.224a4.467 4.467 0 0 1-.007-.398l.002-.148c.002-.586.364-.78.792-.848a7.567 7.567 0 0 1 2.288-.016c.441.062.734.346.794.79.036.274.064.55.064.825.006.608.005 1.218.004 1.827l-.001.73Zm-2.247 1.156c.135.017.282.02.417 0 .37-.054.646-.442.593-.785a5.054 5.054 0 0 1-.066-.677 33.08 33.08 0 0 1-.004-.971l.001-.415c.02-.431-.116-.453-.254-.461-1.046-.071-1.065.035-1.065.357-.003.498-.001.996 0 1.494l.003.896c0 .05.003.098.008.145.036.248.152.39.367.417Z',
                    fill: '#E3E4E9',
                  }),
                ),
                /*#__PURE__*/ React.createElement(
                  'g',
                  null,
                  /*#__PURE__*/ React.createElement(
                    'mask',
                    {
                      id: `bi_slash__n_${id_13}`,
                      style: {
                        maskType: 'alpha',
                      },
                      maskUnits: 'userSpaceOnUse',
                      x: 4,
                      y: 11,
                      width: 24,
                      height: 8,
                    },
                    /*#__PURE__*/ React.createElement(
                      'g',
                      null,
                      /*#__PURE__*/ React.createElement('path', {
                        fillRule: 'evenodd',
                        clipRule: 'evenodd',
                        d: 'M11.637 18.267V15.59l-.005-.333.014-3.765a8.798 8.798 0 0 1-1.902.363v.068c.276.13.458.265.541.398.08.13.08.415.08.84v4.587s0 .014.003.02v.122h-.003s0 .022.003.03c0 .248 0 .5.003.748 0 .109.088.194.196.194h1.068l.194-.002a7.08 7.08 0 0 1 .39.002l.01-.058-.021-.005c-.016-.005-.032-.01-.049-.011-.378-.05-.5-.161-.527-.518l.005-.003ZM7.65 13.503c-.042.005-.1.038-.11.074-.009.03.016.1.057.114.08.027.326.05.326.05.058.008.113.01.157.01.075 0 .141.003.203.006.162.006.295.012.479-.036.63-.16.759-.977.535-1.454-.204-.437-.618-.548-1.043-.568a22.277 22.277 0 0 0-1.86 0c-.22.009-.458.085-.654.189-.445.232-.56.65-.552 1.113.005.398.11.486.513.428l.11-.015c.18-.026.36-.052.542-.061.13-.006.234.055.231.216-.005.152-.093.218-.234.212a3.298 3.298 0 0 1-.265-.025 6.606 6.606 0 0 0-.133-.016 5.68 5.68 0 0 1-.152-.018 2.678 2.678 0 0 0-.336-.028c-.21 0-.287.12-.24.325.077.322.309.496.596.608.342.132.642.24.956.352.168.06.34.121.523.188.07.025.238.112.318.156 0 0 .165.109.262.175.1.068.116.231.118.349l.001.428c.003.6.005 1.202-.03 1.8-.042.678-.467.73-.95.65-.177-.027-.274-.142-.329-.289a.768.768 0 0 1-.044-.237l-.039-1.545a3.129 3.129 0 0 1-.022-.166 1.33 1.33 0 0 0-.074-.355 1.046 1.046 0 0 0-.301-.43 1.064 1.064 0 0 0-.497-.192 1.349 1.349 0 0 0-.971.232c.336.046.403.284.436.54.012.086.012.174.013.262v1.144c.006.753.495 1.143 1.154 1.184.624.035 1.253.035 1.88 0 .585-.033 1.087-.336 1.145-.98.047-.531.034-1.069.021-1.603a102.29 102.29 0 0 1-.004-.176c-.006-.295-.19-.505-.467-.611a11.3 11.3 0 0 0-.844-.284l-.483-.15a7.995 7.995 0 0 0-.22-.092 3.83 3.83 0 0 1-.44-.203c-.218-.122-.323-.332-.35-.58-.017-.134.01-.205.168-.23.273-.044.37-.17.359-.412-.008-.216-.094-.32-.329-.363-.154-.027-.232-.09-.204-.25.013-.083.023-.166.032-.249.02-.179.041-.358.098-.524.096-.287.375-.382.764-.33.274.038.453.194.48.486.028.278.025.562.009.84-.011.177-.1.32-.31.344v-.003Zm19.052 4.766c.025.358.14.47.496.519l-.002.005c.014.002.027.006.04.01a.456.456 0 0 0 .023.006l-.008.058c-.121-.006-.244-.004-.367-.002l-.185.002h-1.01a.188.188 0 0 1-.185-.194c0-.248 0-.5-.006-.748v-.739l.008-1.282v-.055c0-.783-.267-1.173-.808-1.173-.417 0-.795.237-1.131.715v2.88c.027.358.148.47.527.52a.287.287 0 0 1 .048.01l.02.006-.008.057a6.98 6.98 0 0 0-.39-.002l-.195.002h-1.068a.194.194 0 0 1-.196-.194c-.003-.248-.003-.499-.003-.747-.002-.009-.002-.03-.002-.03h.002v-.123c-.002-.006-.002-.02-.002-.02v-4.545c0-.382 0-.655-.05-.81a.336.336 0 0 0-.033-.071c-.083-.134-.265-.268-.541-.399v-.068l.036-.003.036-.002a8.746 8.746 0 0 0 1.832-.358l-.013 3.572c.469-.685 1.048-1.026 1.738-1.026.373 0 .701.115.977.347.279.231.42.586.42 1.072v2.81Zm-5.234-3.595-.002-.047a1.166 1.166 0 0 0-.007-.095c-.058-.529-.33-.876-.767-.944a7.31 7.31 0 0 0-2.313.009c-.361.06-.665.261-.731.633a4.585 4.585 0 0 0-.058 1.115c.028.396.315.603.693.674.16.03.322.05.492.07l.245.031c1.175.123 1.131.734 1.131.734a20.02 20.02 0 0 1 0 1.63c-.008.258-.176.392-.441.411a2.405 2.405 0 0 1-.147.006c-.543.005-.687-.123-.709-.666-.008-.215-.008-.43-.007-.645 0-.144.001-.287-.001-.43-.003-.287-.1-.42-.334-.497a.462.462 0 0 0-.392.052l-.69.453c-.074.05-.145.105-.216.162l-.104.081.016.05c.027 0 .053.004.08.007.055.006.11.012.163.009.133-.006.182.049.188.177.004.125.023.248.042.37l.013.09c.06.424.284.705.707.784.772.142 1.553.12 2.332.02.422-.055.704-.31.756-.732.05-.401.064-.808.055-1.212-.008-.36-.198-.635-.56-.73a5.3 5.3 0 0 0-.633-.116 13.088 13.088 0 0 1-.272-.04l-.483-.08c-.4-.079-.516-.294-.516-.294-.064-.09-.125-.208-.125-.311 0-.48.014-.963.039-1.444.008-.188.135-.31.326-.33a2.22 2.22 0 0 1 .554-.005c.246.035.35.166.37.415.017.226.028.453.025.679-.003.235.05.434.224.573.105.082.24.114.372.09l.93-.161v-.052c-.233-.06-.236-.224-.238-.388-.001-.035-.002-.071-.005-.106h-.002Zm-4.945 3.024c0 .171 0 .346.008.52l.006.006c.019.398.135.521.53.57a.287.287 0 0 1 .048.011l.02.006-.008.057a6.06 6.06 0 0 0-.357-.002c-.515.005-1.029.011-1.412-.503l-.01.017c-.047.078-.08.134-.117.19-.149.224-.348.374-.626.374h-.16c-.3.002-.602.003-.897-.03-.597-.065-.909-.404-.936-1.026a27.63 27.63 0 0 1-.006-1.656.84.84 0 0 1 .715-.818c.215-.035.436-.035.657-.034.076 0 .153 0 .23-.002l1.015.014v-.808c0-.125 0-.25-.008-.376-.036-.56-.285-.75-.85-.658-.31.05-.437.18-.453.491-.008.088-.008.172-.008.257a.11.11 0 0 1 .002.03.848.848 0 0 1 .006.087l.003.044c.002.03.003.063.003.095.002.15.003.299.217.355v.049l-.623.11c-.527.119-.596.108-.705.092h-.002c-.138-.022-.207-.08-.218-.224a4.467 4.467 0 0 1-.007-.398l.002-.148c.002-.586.364-.78.792-.848a7.567 7.567 0 0 1 2.288-.016c.441.062.734.346.794.79.036.274.064.55.064.825.006.608.005 1.218.004 1.827l-.001.73Zm-2.247 1.156c.135.017.282.02.417 0 .37-.054.646-.442.593-.785a5.054 5.054 0 0 1-.066-.677 33.08 33.08 0 0 1-.004-.971l.001-.415c.02-.431-.116-.453-.254-.461-1.046-.071-1.065.035-1.065.357-.003.498-.001.996 0 1.494l.003.896c0 .05.003.098.008.145.036.248.152.39.367.417Z',
                        fill: '#E3E4E9',
                      }),
                    ),
                  ),
                  /*#__PURE__*/ React.createElement(
                    'g',
                    {
                      mask: `url(#bi_slash__n_${id_13})`,
                    },
                    /*#__PURE__*/ React.createElement(
                      'g',
                      null,
                      /*#__PURE__*/ React.createElement(
                        'g',
                        {
                          style: {
                            mixBlendMode: 'overlay',
                          },
                          filter: `url(#bi_slash__o_${id_14})`,
                        },
                        /*#__PURE__*/ React.createElement('path', {
                          fillRule: 'evenodd',
                          clipRule: 'evenodd',
                          d: 'M11.637 18.267V15.59l-.005-.333.014-3.765a8.798 8.798 0 0 1-1.902.363v.068c.276.13.458.265.541.398.08.13.08.415.08.84v4.587s0 .014.003.02v.122h-.003s0 .022.003.03c0 .248 0 .5.003.748 0 .109.088.194.196.194h1.068l.194-.002a7.08 7.08 0 0 1 .39.002l.01-.058-.021-.005c-.016-.005-.032-.01-.049-.011-.378-.05-.5-.161-.527-.518l.005-.003ZM7.65 13.503c-.042.005-.1.038-.11.074-.009.03.016.1.057.114.08.027.326.05.326.05.058.008.113.01.157.01.075 0 .141.003.203.006.162.006.295.012.479-.036.63-.16.759-.977.535-1.454-.204-.437-.618-.548-1.043-.568a22.277 22.277 0 0 0-1.86 0c-.22.009-.458.085-.654.189-.445.232-.56.65-.552 1.113.005.398.11.486.513.428l.11-.015c.18-.026.36-.052.542-.061.13-.006.234.055.231.216-.005.152-.093.218-.234.212a3.298 3.298 0 0 1-.265-.025 6.606 6.606 0 0 0-.133-.016 5.68 5.68 0 0 1-.152-.018 2.678 2.678 0 0 0-.336-.028c-.21 0-.287.12-.24.325.077.322.309.496.596.608.342.132.642.24.956.352.168.06.34.121.523.188.07.025.238.112.318.156 0 0 .165.109.262.175.1.068.116.231.118.349l.001.428c.003.6.005 1.202-.03 1.8-.042.678-.467.73-.95.65-.177-.027-.274-.142-.329-.289a.768.768 0 0 1-.044-.237l-.039-1.545a3.129 3.129 0 0 1-.022-.166 1.33 1.33 0 0 0-.074-.355 1.046 1.046 0 0 0-.301-.43 1.064 1.064 0 0 0-.497-.192 1.349 1.349 0 0 0-.971.232c.336.046.403.284.436.54.012.086.012.174.013.262v1.144c.006.753.495 1.143 1.154 1.184.624.035 1.253.035 1.88 0 .585-.033 1.087-.336 1.145-.98.047-.531.034-1.069.021-1.603a102.29 102.29 0 0 1-.004-.176c-.006-.295-.19-.505-.467-.611a11.3 11.3 0 0 0-.844-.284l-.483-.15a7.995 7.995 0 0 0-.22-.092 3.83 3.83 0 0 1-.44-.203c-.218-.122-.323-.332-.35-.58-.017-.134.01-.205.168-.23.273-.044.37-.17.359-.412-.008-.216-.094-.32-.329-.363-.154-.027-.232-.09-.204-.25.013-.083.023-.166.032-.249.02-.179.041-.358.098-.524.096-.287.375-.382.764-.33.274.038.453.194.48.486.028.278.025.562.009.84-.011.177-.1.32-.31.344v-.003Zm19.052 4.766c.025.358.14.47.496.519l-.002.005c.014.002.027.006.04.01a.456.456 0 0 0 .023.006l-.008.058c-.121-.006-.244-.004-.367-.002l-.185.002h-1.01a.188.188 0 0 1-.185-.194c0-.248 0-.5-.006-.748v-.739l.008-1.282v-.055c0-.783-.267-1.173-.808-1.173-.417 0-.795.237-1.131.715v2.88c.027.358.148.47.527.52a.287.287 0 0 1 .048.01l.02.006-.008.057a6.98 6.98 0 0 0-.39-.002l-.195.002h-1.068a.194.194 0 0 1-.196-.194c-.003-.248-.003-.499-.003-.747-.002-.009-.002-.03-.002-.03h.002v-.123c-.002-.006-.002-.02-.002-.02v-4.545c0-.382 0-.655-.05-.81a.336.336 0 0 0-.033-.071c-.083-.134-.265-.268-.541-.399v-.068l.036-.003.036-.002a8.746 8.746 0 0 0 1.832-.358l-.013 3.572c.469-.685 1.048-1.026 1.738-1.026.373 0 .701.115.977.347.279.231.42.586.42 1.072v2.81Zm-5.234-3.595-.002-.047a1.166 1.166 0 0 0-.007-.095c-.058-.529-.33-.876-.767-.944a7.31 7.31 0 0 0-2.313.009c-.361.06-.665.261-.731.633a4.585 4.585 0 0 0-.058 1.115c.028.396.315.603.693.674.16.03.322.05.492.07l.245.031c1.175.123 1.131.734 1.131.734a20.02 20.02 0 0 1 0 1.63c-.008.258-.176.392-.441.411a2.405 2.405 0 0 1-.147.006c-.543.005-.687-.123-.709-.666-.008-.215-.008-.43-.007-.645 0-.144.001-.287-.001-.43-.003-.287-.1-.42-.334-.497a.462.462 0 0 0-.392.052l-.69.453c-.074.05-.145.105-.216.162l-.104.081.016.05c.027 0 .053.004.08.007.055.006.11.012.163.009.133-.006.182.049.188.177.004.125.023.248.042.37l.013.09c.06.424.284.705.707.784.772.142 1.553.12 2.332.02.422-.055.704-.31.756-.732.05-.401.064-.808.055-1.212-.008-.36-.198-.635-.56-.73a5.3 5.3 0 0 0-.633-.116 13.088 13.088 0 0 1-.272-.04l-.483-.08c-.4-.079-.516-.294-.516-.294-.064-.09-.125-.208-.125-.311 0-.48.014-.963.039-1.444.008-.188.135-.31.326-.33a2.22 2.22 0 0 1 .554-.005c.246.035.35.166.37.415.017.226.028.453.025.679-.003.235.05.434.224.573.105.082.24.114.372.09l.93-.161v-.052c-.233-.06-.236-.224-.238-.388-.001-.035-.002-.071-.005-.106h-.002Zm-4.945 3.024c0 .171 0 .346.008.52l.006.006c.019.398.135.521.53.57a.287.287 0 0 1 .048.011l.02.006-.008.057a6.06 6.06 0 0 0-.357-.002c-.515.005-1.029.011-1.412-.503l-.01.017c-.047.078-.08.134-.117.19-.149.224-.348.374-.626.374h-.16c-.3.002-.602.003-.897-.03-.597-.065-.909-.404-.936-1.026a27.63 27.63 0 0 1-.006-1.656.84.84 0 0 1 .715-.818c.215-.035.436-.035.657-.034.076 0 .153 0 .23-.002l1.015.014v-.808c0-.125 0-.25-.008-.376-.036-.56-.285-.75-.85-.658-.31.05-.437.18-.453.491-.008.088-.008.172-.008.257a.11.11 0 0 1 .002.03.848.848 0 0 1 .006.087l.003.044c.002.03.003.063.003.095.002.15.003.299.217.355v.049l-.623.11c-.527.119-.596.108-.705.092h-.002c-.138-.022-.207-.08-.218-.224a4.467 4.467 0 0 1-.007-.398l.002-.148c.002-.586.364-.78.792-.848a7.567 7.567 0 0 1 2.288-.016c.441.062.734.346.794.79.036.274.064.55.064.825.006.608.005 1.218.004 1.827l-.001.73Zm-2.247 1.156c.135.017.282.02.417 0 .37-.054.646-.442.593-.785a5.054 5.054 0 0 1-.066-.677 33.08 33.08 0 0 1-.004-.971l.001-.415c.02-.431-.116-.453-.254-.461-1.046-.071-1.065.035-1.065.357-.003.498-.001.996 0 1.494l.003.896c0 .05.003.098.008.145.036.248.152.39.367.417Z',
                          fill: `url(#bi_slash__p_${id_15})`,
                        }),
                      ),
                      /*#__PURE__*/ React.createElement(
                        'g',
                        {
                          filter: `url(#bi_slash__q_${id_16})`,
                        },
                        /*#__PURE__*/ React.createElement('path', {
                          d: 'M18.328 23.275c-5.597-4.447-5.431-8.279-3.05-11.276C17.66 9.002 20.87-3.386 24.936-.155c4.066 3.23 8.596 14.856 6.215 17.854-2.382 2.996-8.756 8.807-12.823 5.576Z',
                          fill: '#271F17',
                        }),
                      ),
                      /*#__PURE__*/ React.createElement(
                        'g',
                        {
                          filter: `url(#bi_slash__r_${id_17})`,
                        },
                        /*#__PURE__*/ React.createElement('path', {
                          d: 'M4.621 7.735c7.666-3.852 11.53-2.189 13.313 1.36 1.783 3.55 12.801 11.596 7.232 14.394-5.569 2.799-20.055 2.78-21.839-.77C1.544 19.172-.948 10.535 4.621 7.736Z',
                          fill: '#BEA68A',
                        }),
                      ),
                      /*#__PURE__*/ React.createElement(
                        'g',
                        {
                          style: {
                            mixBlendMode: 'hard-light',
                          },
                          opacity: 0.74,
                          filter: `url(#bi_slash__s_${id_18})`,
                        },
                        /*#__PURE__*/ React.createElement('path', {
                          d: 'M22.284 27.537c-5.38-1.168-6.699-3.271-6.234-5.412.464-2.14-2.024-9.527 1.884-8.68 3.907.85 11.255 6.123 10.79 8.264-.464 2.14-2.533 6.676-6.44 5.828Z',
                          fill: '#C39044',
                        }),
                      ),
                      /*#__PURE__*/ React.createElement(
                        'g',
                        {
                          opacity: 0.7,
                          filter: `url(#bi_slash__t_${id_19})`,
                        },
                        /*#__PURE__*/ React.createElement('path', {
                          d: 'M12.577 16.642c2.378-1.195 4.054.272 5.196 2.545 1.143 2.274 6.36 8.352 4.633 9.22-1.728.868-7.19-1.062-8.331-3.336-1.143-2.273-3.226-7.56-1.498-8.429Z',
                          fill: '#E5DCB8',
                        }),
                      ),
                      /*#__PURE__*/ React.createElement(
                        'g',
                        {
                          filter: `url(#bi_slash__u_${id_20})`,
                        },
                        /*#__PURE__*/ React.createElement('path', {
                          d: 'M.463 20.52c-4.57-2.875-4.36-6.409-2.321-9.649C.18 7.631 3.088-4.358 6.409-2.269c3.32 2.09 6.866 11.745 4.828 14.985C9.198 15.956 3.784 22.61.463 20.52Z',
                          fill: '#202128',
                          fillOpacity: 0.4,
                        }),
                      ),
                      /*#__PURE__*/ React.createElement(
                        'g',
                        {
                          filter: `url(#bi_slash__v_${id_21})`,
                        },
                        /*#__PURE__*/ React.createElement('path', {
                          d: 'M4.72 11.136c.854-1.095 1.495-1.15 1.953-.792.458.357 2.479.655 1.858 1.45-.62.795-2.66 1.859-3.119 1.501-.458-.357-1.313-1.364-.692-2.159Z',
                          fill: '#B8CDE5',
                        }),
                      ),
                      /*#__PURE__*/ React.createElement(
                        'g',
                        {
                          filter: `url(#bi_slash__w_${id_22})`,
                        },
                        /*#__PURE__*/ React.createElement('path', {
                          d: 'M17.805 21.326c3.827 0 6.93-.755 6.93-1.687s-3.103-1.687-6.93-1.687c-3.827 0-6.929.755-6.929 1.687s3.102 1.688 6.93 1.688Z',
                          fill: '#fff',
                          fillOpacity: 0.5,
                        }),
                      ),
                      /*#__PURE__*/ React.createElement(
                        'g',
                        {
                          opacity: 0.2,
                          filter: `url(#bi_slash__x_${id_23})`,
                        },
                        /*#__PURE__*/ React.createElement('path', {
                          fillRule: 'evenodd',
                          clipRule: 'evenodd',
                          d: 'M11.637 18.267V15.59l-.005-.333.014-3.765a8.798 8.798 0 0 1-1.902.363v.068c.276.13.458.265.541.398.08.13.08.415.08.84v4.587s0 .014.003.02v.122h-.003s0 .022.003.03c0 .248 0 .5.003.748 0 .109.088.194.196.194h1.068l.194-.002a7.08 7.08 0 0 1 .39.002l.01-.058-.021-.005c-.016-.005-.032-.01-.049-.011-.378-.05-.5-.161-.527-.518l.005-.003ZM7.65 13.503c-.042.005-.1.038-.11.074-.009.03.016.1.057.114.08.027.326.05.326.05.058.008.113.01.157.01.075 0 .141.003.203.006.162.006.295.012.479-.036.63-.16.759-.977.535-1.454-.204-.437-.618-.548-1.043-.568a22.277 22.277 0 0 0-1.86 0c-.22.009-.458.085-.654.189-.445.232-.56.65-.552 1.113.005.398.11.486.513.428l.11-.015c.18-.026.36-.052.542-.061.13-.006.234.055.231.216-.005.152-.093.218-.234.212a3.298 3.298 0 0 1-.265-.025 6.606 6.606 0 0 0-.133-.016 5.68 5.68 0 0 1-.152-.018 2.678 2.678 0 0 0-.336-.028c-.21 0-.287.12-.24.325.077.322.309.496.596.608.342.132.642.24.956.352.168.06.34.121.523.188.07.025.238.112.318.156 0 0 .165.109.262.175.1.068.116.231.118.349l.001.428c.003.6.005 1.202-.03 1.8-.042.678-.467.73-.95.65-.177-.027-.274-.142-.329-.289a.768.768 0 0 1-.044-.237l-.039-1.545a3.129 3.129 0 0 1-.022-.166 1.33 1.33 0 0 0-.074-.355 1.046 1.046 0 0 0-.301-.43 1.064 1.064 0 0 0-.497-.192 1.349 1.349 0 0 0-.971.232c.336.046.403.284.436.54.012.086.012.174.013.262v1.144c.006.753.495 1.143 1.154 1.184.624.035 1.253.035 1.88 0 .585-.033 1.087-.336 1.145-.98.047-.531.034-1.069.021-1.603a102.29 102.29 0 0 1-.004-.176c-.006-.295-.19-.505-.467-.611a11.3 11.3 0 0 0-.844-.284l-.483-.15a7.995 7.995 0 0 0-.22-.092 3.83 3.83 0 0 1-.44-.203c-.218-.122-.323-.332-.35-.58-.017-.134.01-.205.168-.23.273-.044.37-.17.359-.412-.008-.216-.094-.32-.329-.363-.154-.027-.232-.09-.204-.25.013-.083.023-.166.032-.249.02-.179.041-.358.098-.524.096-.287.375-.382.764-.33.274.038.453.194.48.486.028.278.025.562.009.84-.011.177-.1.32-.31.344v-.003Zm19.052 4.766c.025.358.14.47.496.519l-.002.005c.014.002.027.006.04.01a.456.456 0 0 0 .023.006l-.008.058c-.121-.006-.244-.004-.367-.002l-.185.002h-1.01a.188.188 0 0 1-.185-.194c0-.248 0-.5-.006-.748v-.739l.008-1.282v-.055c0-.783-.267-1.173-.808-1.173-.417 0-.795.237-1.131.715v2.88c.027.358.148.47.527.52a.287.287 0 0 1 .048.01l.02.006-.008.057a6.98 6.98 0 0 0-.39-.002l-.195.002h-1.068a.194.194 0 0 1-.196-.194c-.003-.248-.003-.499-.003-.747-.002-.009-.002-.03-.002-.03h.002v-.123c-.002-.006-.002-.02-.002-.02v-4.545c0-.382 0-.655-.05-.81a.336.336 0 0 0-.033-.071c-.083-.134-.265-.268-.541-.399v-.068l.036-.003.036-.002a8.746 8.746 0 0 0 1.832-.358l-.013 3.572c.469-.685 1.048-1.026 1.738-1.026.373 0 .701.115.977.347.279.231.42.586.42 1.072v2.81Zm-5.234-3.595-.002-.047a1.166 1.166 0 0 0-.007-.095c-.058-.529-.33-.876-.767-.944a7.31 7.31 0 0 0-2.313.009c-.361.06-.665.261-.731.633a4.585 4.585 0 0 0-.058 1.115c.028.396.315.603.693.674.16.03.322.05.492.07l.245.031c1.175.123 1.131.734 1.131.734a20.02 20.02 0 0 1 0 1.63c-.008.258-.176.392-.441.411a2.405 2.405 0 0 1-.147.006c-.543.005-.687-.123-.709-.666-.008-.215-.008-.43-.007-.645 0-.144.001-.287-.001-.43-.003-.287-.1-.42-.334-.497a.462.462 0 0 0-.392.052l-.69.453c-.074.05-.145.105-.216.162l-.104.081.016.05c.027 0 .053.004.08.007.055.006.11.012.163.009.133-.006.182.049.188.177.004.125.023.248.042.37l.013.09c.06.424.284.705.707.784.772.142 1.553.12 2.332.02.422-.055.704-.31.756-.732.05-.401.064-.808.055-1.212-.008-.36-.198-.635-.56-.73a5.3 5.3 0 0 0-.633-.116 13.088 13.088 0 0 1-.272-.04l-.483-.08c-.4-.079-.516-.294-.516-.294-.064-.09-.125-.208-.125-.311 0-.48.014-.963.039-1.444.008-.188.135-.31.326-.33a2.22 2.22 0 0 1 .554-.005c.246.035.35.166.37.415.017.226.028.453.025.679-.003.235.05.434.224.573.105.082.24.114.372.09l.93-.161v-.052c-.233-.06-.236-.224-.238-.388-.001-.035-.002-.071-.005-.106h-.002Zm-4.945 3.024c0 .171 0 .346.008.52l.006.006c.019.398.135.521.53.57a.287.287 0 0 1 .048.011l.02.006-.008.057a6.06 6.06 0 0 0-.357-.002c-.515.005-1.029.011-1.412-.503l-.01.017c-.047.078-.08.134-.117.19-.149.224-.348.374-.626.374h-.16c-.3.002-.602.003-.897-.03-.597-.065-.909-.404-.936-1.026a27.63 27.63 0 0 1-.006-1.656.84.84 0 0 1 .715-.818c.215-.035.436-.035.657-.034.076 0 .153 0 .23-.002l1.015.014v-.808c0-.125 0-.25-.008-.376-.036-.56-.285-.75-.85-.658-.31.05-.437.18-.453.491-.008.088-.008.172-.008.257a.11.11 0 0 1 .002.03.848.848 0 0 1 .006.087l.003.044c.002.03.003.063.003.095.002.15.003.299.217.355v.049l-.623.11c-.527.119-.596.108-.705.092h-.002c-.138-.022-.207-.08-.218-.224a4.467 4.467 0 0 1-.007-.398l.002-.148c.002-.586.364-.78.792-.848a7.567 7.567 0 0 1 2.288-.016c.441.062.734.346.794.79.036.274.064.55.064.825.006.608.005 1.218.004 1.827l-.001.73Zm-2.247 1.156c.135.017.282.02.417 0 .37-.054.646-.442.593-.785a5.054 5.054 0 0 1-.066-.677 33.08 33.08 0 0 1-.004-.971l.001-.415c.02-.431-.116-.453-.254-.461-1.046-.071-1.065.035-1.065.357-.003.498-.001.996 0 1.494l.003.896c0 .05.003.098.008.145.036.248.152.39.367.417Z',
                          fill: `url(#bi_slash__y_${id_24})`,
                        }),
                      ),
                      /*#__PURE__*/ React.createElement(
                        'g',
                        null,
                        /*#__PURE__*/ React.createElement(
                          'mask',
                          {
                            id: `bi_slash__A_${id_25}`,
                            style: {
                              maskType: 'alpha',
                            },
                            maskUnits: 'userSpaceOnUse',
                            x: 3,
                            y: 10,
                            width: 26,
                            height: 10,
                          },
                          /*#__PURE__*/ React.createElement(
                            'g',
                            null,
                            /*#__PURE__*/ React.createElement(
                              'g',
                              {
                                style: {
                                  mixBlendMode: 'overlay',
                                },
                                opacity: 0.4,
                              },
                              /*#__PURE__*/ React.createElement('path', {
                                d: 'M3.026 10.138v9.51h25.21v-9.51H3.025Z',
                                fill: `url(#bi_slash__z_${id_26})`,
                              }),
                            ),
                          ),
                        ),
                        /*#__PURE__*/ React.createElement(
                          'g',
                          {
                            mask: `url(#bi_slash__A_${id_25})`,
                          },
                          /*#__PURE__*/ React.createElement(
                            'g',
                            null,
                            /*#__PURE__*/ React.createElement(
                              'g',
                              {
                                opacity: 0.5,
                              },
                              /*#__PURE__*/ React.createElement(
                                'g',
                                {
                                  opacity: 0.4,
                                  filter: `url(#bi_slash__B_${id_27})`,
                                },
                                /*#__PURE__*/ React.createElement('path', {
                                  d: 'M33.385 18.474c4.922-3.316 4.333-8.88-1.315-12.428-5.65-3.547-14.218-3.734-19.14-.418-4.922 3.316-4.333 8.88 1.315 12.428 5.649 3.547 14.218 3.735 19.14.418Z',
                                  fill: '#A98B6A',
                                }),
                              ),
                              /*#__PURE__*/ React.createElement(
                                'g',
                                {
                                  filter: `url(#bi_slash__C_${id_28})`,
                                },
                                /*#__PURE__*/ React.createElement('path', {
                                  d: 'M21.184 22.137c1.347-.907-2.493-4.74-8.578-8.562C6.52 9.753.496 7.39-.851 8.299c-1.347.908 2.494 4.741 8.579 8.563 6.085 3.82 12.11 6.183 13.456 5.275Z',
                                  fill: '#D9D9D9',
                                }),
                              ),
                            ),
                          ),
                        ),
                      ),
                      /*#__PURE__*/ React.createElement(
                        'g',
                        null,
                        /*#__PURE__*/ React.createElement(
                          'mask',
                          {
                            id: `bi_slash__E_${id_29}`,
                            style: {
                              maskType: 'alpha',
                            },
                            maskUnits: 'userSpaceOnUse',
                            x: 2,
                            y: 7,
                            width: 27,
                            height: 18,
                          },
                          /*#__PURE__*/ React.createElement(
                            'g',
                            null,
                            /*#__PURE__*/ React.createElement('path', {
                              d: 'M28.686 7.45H2.9v16.774h25.787V7.45Z',
                              fill: `url(#bi_slash__D_${id_30})`,
                            }),
                          ),
                        ),
                        /*#__PURE__*/ React.createElement(
                          'g',
                          {
                            mask: `url(#bi_slash__E_${id_29})`,
                          },
                          /*#__PURE__*/ React.createElement(
                            'g',
                            null,
                            /*#__PURE__*/ React.createElement(
                              'g',
                              {
                                filter: `url(#bi_slash__F_${id_31})`,
                              },
                              /*#__PURE__*/ React.createElement('path', {
                                d: 'M10.207 18.677c3.314-1.245 3.954-4.56 1.429-7.406C9.11 8.426 4.376 7.13 1.063 8.373c-3.315 1.245-3.954 4.56-1.43 7.406 2.526 2.845 7.26 4.142 10.574 2.898Z',
                                fill: '#898989',
                              }),
                            ),
                            /*#__PURE__*/ React.createElement(
                              'g',
                              {
                                opacity: 0.96,
                                filter: `url(#bi_slash__G_${id_32})`,
                              },
                              /*#__PURE__*/ React.createElement('path', {
                                d: 'M27.902 24.188c2.074-.779 1.708-3.717-.817-6.562s-6.254-4.52-8.328-3.741c-2.074.779-1.708 3.717.817 6.562s6.254 4.52 8.328 3.741Z',
                                fill: '#51401E',
                              }),
                            ),
                          ),
                        ),
                      ),
                      /*#__PURE__*/ React.createElement(
                        'g',
                        {
                          style: {
                            mixBlendMode: 'overlay',
                          },
                          filter: `url(#bi_slash__H_${id_33})`,
                        },
                        /*#__PURE__*/ React.createElement('path', {
                          fillRule: 'evenodd',
                          clipRule: 'evenodd',
                          d: 'M11.637 18.267V15.59l-.005-.333.014-3.765a8.798 8.798 0 0 1-1.902.363v.068c.276.13.458.265.541.398.08.13.08.415.08.84v4.587s0 .014.003.02v.122h-.003s0 .022.003.03c0 .248 0 .5.003.748 0 .109.088.194.196.194h1.068l.194-.002a7.08 7.08 0 0 1 .39.002l.01-.058-.021-.005c-.016-.005-.032-.01-.049-.011-.378-.05-.5-.161-.527-.518l.005-.003ZM7.65 13.503c-.042.005-.1.038-.11.074-.009.03.016.1.057.114.08.027.326.05.326.05.058.008.113.01.157.01.075 0 .141.003.203.006.162.006.295.012.479-.036.63-.16.759-.977.535-1.454-.204-.437-.618-.548-1.043-.568a22.277 22.277 0 0 0-1.86 0c-.22.009-.458.085-.654.189-.445.232-.56.65-.552 1.113.005.398.11.486.513.428l.11-.015c.18-.026.36-.052.542-.061.13-.006.234.055.231.216-.005.152-.093.218-.234.212a3.298 3.298 0 0 1-.265-.025 6.606 6.606 0 0 0-.133-.016 5.68 5.68 0 0 1-.152-.018 2.678 2.678 0 0 0-.336-.028c-.21 0-.287.12-.24.325.077.322.309.496.596.608.342.132.642.24.956.352.168.06.34.121.523.188.07.025.238.112.318.156 0 0 .165.109.262.175.1.068.116.231.118.349l.001.428c.003.6.005 1.202-.03 1.8-.042.678-.467.73-.95.65-.177-.027-.274-.142-.329-.289a.768.768 0 0 1-.044-.237l-.039-1.545a3.129 3.129 0 0 1-.022-.166 1.33 1.33 0 0 0-.074-.355 1.046 1.046 0 0 0-.301-.43 1.064 1.064 0 0 0-.497-.192 1.349 1.349 0 0 0-.971.232c.336.046.403.284.436.54.012.086.012.174.013.262v1.144c.006.753.495 1.143 1.154 1.184.624.035 1.253.035 1.88 0 .585-.033 1.087-.336 1.145-.98.047-.531.034-1.069.021-1.603a102.29 102.29 0 0 1-.004-.176c-.006-.295-.19-.505-.467-.611a11.3 11.3 0 0 0-.844-.284l-.483-.15a7.995 7.995 0 0 0-.22-.092 3.83 3.83 0 0 1-.44-.203c-.218-.122-.323-.332-.35-.58-.017-.134.01-.205.168-.23.273-.044.37-.17.359-.412-.008-.216-.094-.32-.329-.363-.154-.027-.232-.09-.204-.25.013-.083.023-.166.032-.249.02-.179.041-.358.098-.524.096-.287.375-.382.764-.33.274.038.453.194.48.486.028.278.025.562.009.84-.011.177-.1.32-.31.344v-.003Zm19.052 4.766c.025.358.14.47.496.519l-.002.005c.014.002.027.006.04.01a.456.456 0 0 0 .023.006l-.008.058c-.121-.006-.244-.004-.367-.002l-.185.002h-1.01a.188.188 0 0 1-.185-.194c0-.248 0-.5-.006-.748v-.739l.008-1.282v-.055c0-.783-.267-1.173-.808-1.173-.417 0-.795.237-1.131.715v2.88c.027.358.148.47.527.52a.287.287 0 0 1 .048.01l.02.006-.008.057a6.98 6.98 0 0 0-.39-.002l-.195.002h-1.068a.194.194 0 0 1-.196-.194c-.003-.248-.003-.499-.003-.747-.002-.009-.002-.03-.002-.03h.002v-.123c-.002-.006-.002-.02-.002-.02v-4.545c0-.382 0-.655-.05-.81a.336.336 0 0 0-.033-.071c-.083-.134-.265-.268-.541-.399v-.068l.036-.003.036-.002a8.746 8.746 0 0 0 1.832-.358l-.013 3.572c.469-.685 1.048-1.026 1.738-1.026.373 0 .701.115.977.347.279.231.42.586.42 1.072v2.81Zm-5.234-3.595-.002-.047a1.166 1.166 0 0 0-.007-.095c-.058-.529-.33-.876-.767-.944a7.31 7.31 0 0 0-2.313.009c-.361.06-.665.261-.731.633a4.585 4.585 0 0 0-.058 1.115c.028.396.315.603.693.674.16.03.322.05.492.07l.245.031c1.175.123 1.131.734 1.131.734a20.02 20.02 0 0 1 0 1.63c-.008.258-.176.392-.441.411a2.405 2.405 0 0 1-.147.006c-.543.005-.687-.123-.709-.666-.008-.215-.008-.43-.007-.645 0-.144.001-.287-.001-.43-.003-.287-.1-.42-.334-.497a.462.462 0 0 0-.392.052l-.69.453c-.074.05-.145.105-.216.162l-.104.081.016.05c.027 0 .053.004.08.007.055.006.11.012.163.009.133-.006.182.049.188.177.004.125.023.248.042.37l.013.09c.06.424.284.705.707.784.772.142 1.553.12 2.332.02.422-.055.704-.31.756-.732.05-.401.064-.808.055-1.212-.008-.36-.198-.635-.56-.73a5.3 5.3 0 0 0-.633-.116 13.088 13.088 0 0 1-.272-.04l-.483-.08c-.4-.079-.516-.294-.516-.294-.064-.09-.125-.208-.125-.311 0-.48.014-.963.039-1.444.008-.188.135-.31.326-.33a2.22 2.22 0 0 1 .554-.005c.246.035.35.166.37.415.017.226.028.453.025.679-.003.235.05.434.224.573.105.082.24.114.372.09l.93-.161v-.052c-.233-.06-.236-.224-.238-.388-.001-.035-.002-.071-.005-.106h-.002Zm-4.945 3.024c0 .171 0 .346.008.52l.006.006c.019.398.135.521.53.57a.287.287 0 0 1 .048.011l.02.006-.008.057a6.06 6.06 0 0 0-.357-.002c-.515.005-1.029.011-1.412-.503l-.01.017c-.047.078-.08.134-.117.19-.149.224-.348.374-.626.374h-.16c-.3.002-.602.003-.897-.03-.597-.065-.909-.404-.936-1.026a27.63 27.63 0 0 1-.006-1.656.84.84 0 0 1 .715-.818c.215-.035.436-.035.657-.034.076 0 .153 0 .23-.002l1.015.014v-.808c0-.125 0-.25-.008-.376-.036-.56-.285-.75-.85-.658-.31.05-.437.18-.453.491-.008.088-.008.172-.008.257a.11.11 0 0 1 .002.03.848.848 0 0 1 .006.087l.003.044c.002.03.003.063.003.095.002.15.003.299.217.355v.049l-.623.11c-.527.119-.596.108-.705.092h-.002c-.138-.022-.207-.08-.218-.224a4.467 4.467 0 0 1-.007-.398l.002-.148c.002-.586.364-.78.792-.848a7.567 7.567 0 0 1 2.288-.016c.441.062.734.346.794.79.036.274.064.55.064.825.006.608.005 1.218.004 1.827l-.001.73Zm-2.247 1.156c.135.017.282.02.417 0 .37-.054.646-.442.593-.785a5.054 5.054 0 0 1-.066-.677 33.08 33.08 0 0 1-.004-.971l.001-.415c.02-.431-.116-.453-.254-.461-1.046-.071-1.065.035-1.065.357-.003.498-.001.996 0 1.494l.003.896c0 .05.003.098.008.145.036.248.152.39.367.417Z',
                          fill: '#fff',
                          fillOpacity: 0.01,
                        }),
                      ),
                    ),
                  ),
                ),
              ),
            ),
          ),
        ),
      ),
    ),
    /*#__PURE__*/ React.createElement(
      'defs',
      null,
      /*#__PURE__*/ React.createElement(
        'filter',
        {
          id: `bi_slash__b_${id_1}`,
          x: -11.655,
          y: -12.256,
          width: 36.873,
          height: 36.768,
          filterUnits: 'userSpaceOnUse',
          colorInterpolationFilters: 'sRGB',
        },
        /*#__PURE__*/ React.createElement('feFlood', {
          floodOpacity: 0,
          result: 'BackgroundImageFix',
        }),
        /*#__PURE__*/ React.createElement('feBlend', {
          in: 'SourceGraphic',
          in2: 'BackgroundImageFix',
          result: 'shape',
        }),
        /*#__PURE__*/ React.createElement('feGaussianBlur', {
          stdDeviation: 5.202,
          result: 'effect1_foregroundBlur_21_107',
        }),
      ),
      /*#__PURE__*/ React.createElement(
        'filter',
        {
          id: `bi_slash__c_${id_2}`,
          x: 2.762,
          y: -2.66,
          width: 45.28,
          height: 41.87,
          filterUnits: 'userSpaceOnUse',
          colorInterpolationFilters: 'sRGB',
        },
        /*#__PURE__*/ React.createElement('feFlood', {
          floodOpacity: 0,
          result: 'BackgroundImageFix',
        }),
        /*#__PURE__*/ React.createElement('feBlend', {
          in: 'SourceGraphic',
          in2: 'BackgroundImageFix',
          result: 'shape',
        }),
        /*#__PURE__*/ React.createElement('feGaussianBlur', {
          stdDeviation: 8.902,
          result: 'effect1_foregroundBlur_21_107',
        }),
      ),
      /*#__PURE__*/ React.createElement(
        'filter',
        {
          id: `bi_slash__d_${id_3}`,
          x: 10.764,
          y: 6.587,
          width: 19.423,
          height: 22.311,
          filterUnits: 'userSpaceOnUse',
          colorInterpolationFilters: 'sRGB',
        },
        /*#__PURE__*/ React.createElement('feFlood', {
          floodOpacity: 0,
          result: 'BackgroundImageFix',
        }),
        /*#__PURE__*/ React.createElement('feBlend', {
          in: 'SourceGraphic',
          in2: 'BackgroundImageFix',
          result: 'shape',
        }),
        /*#__PURE__*/ React.createElement('feGaussianBlur', {
          stdDeviation: 3.602,
          result: 'effect1_foregroundBlur_21_107',
        }),
      ),
      /*#__PURE__*/ React.createElement(
        'filter',
        {
          id: `bi_slash__e_${id_4}`,
          x: 15.49,
          y: 12.425,
          width: 8.313,
          height: 10.069,
          filterUnits: 'userSpaceOnUse',
          colorInterpolationFilters: 'sRGB',
        },
        /*#__PURE__*/ React.createElement('feFlood', {
          floodOpacity: 0,
          result: 'BackgroundImageFix',
        }),
        /*#__PURE__*/ React.createElement('feBlend', {
          in: 'SourceGraphic',
          in2: 'BackgroundImageFix',
          result: 'shape',
        }),
        /*#__PURE__*/ React.createElement('feGaussianBlur', {
          stdDeviation: 1.53,
          result: 'effect1_foregroundBlur_21_107',
        }),
      ),
      /*#__PURE__*/ React.createElement(
        'filter',
        {
          id: `bi_slash__f_${id_5}`,
          x: -39.155,
          y: -25.699,
          width: 73.548,
          height: 73.339,
          filterUnits: 'userSpaceOnUse',
          colorInterpolationFilters: 'sRGB',
        },
        /*#__PURE__*/ React.createElement('feFlood', {
          floodOpacity: 0,
          result: 'BackgroundImageFix',
        }),
        /*#__PURE__*/ React.createElement('feBlend', {
          in: 'SourceGraphic',
          in2: 'BackgroundImageFix',
          result: 'shape',
        }),
        /*#__PURE__*/ React.createElement('feGaussianBlur', {
          stdDeviation: 10.377,
          result: 'effect1_foregroundBlur_21_107',
        }),
      ),
      /*#__PURE__*/ React.createElement(
        'filter',
        {
          id: `bi_slash__g_${id_6}`,
          x: -20.826,
          y: -6.966,
          width: 39.434,
          height: 45.66,
          filterUnits: 'userSpaceOnUse',
          colorInterpolationFilters: 'sRGB',
        },
        /*#__PURE__*/ React.createElement('feFlood', {
          floodOpacity: 0,
          result: 'BackgroundImageFix',
        }),
        /*#__PURE__*/ React.createElement('feBlend', {
          in: 'SourceGraphic',
          in2: 'BackgroundImageFix',
          result: 'shape',
        }),
        /*#__PURE__*/ React.createElement('feGaussianBlur', {
          stdDeviation: 6.226,
          result: 'effect1_foregroundBlur_21_107',
        }),
      ),
      /*#__PURE__*/ React.createElement(
        'filter',
        {
          id: `bi_slash__h_${id_7}`,
          x: -31.203,
          y: -19.834,
          width: 43.48,
          height: 41.509,
          filterUnits: 'userSpaceOnUse',
          colorInterpolationFilters: 'sRGB',
        },
        /*#__PURE__*/ React.createElement('feFlood', {
          floodOpacity: 0,
          result: 'BackgroundImageFix',
        }),
        /*#__PURE__*/ React.createElement('feBlend', {
          in: 'SourceGraphic',
          in2: 'BackgroundImageFix',
          result: 'shape',
        }),
        /*#__PURE__*/ React.createElement('feGaussianBlur', {
          stdDeviation: 5.189,
          result: 'effect1_foregroundBlur_21_107',
        }),
      ),
      /*#__PURE__*/ React.createElement(
        'filter',
        {
          id: `bi_slash__i_${id_8}`,
          x: 8.252,
          y: -14.084,
          width: 73.548,
          height: 73.339,
          filterUnits: 'userSpaceOnUse',
          colorInterpolationFilters: 'sRGB',
        },
        /*#__PURE__*/ React.createElement('feFlood', {
          floodOpacity: 0,
          result: 'BackgroundImageFix',
        }),
        /*#__PURE__*/ React.createElement('feBlend', {
          in: 'SourceGraphic',
          in2: 'BackgroundImageFix',
          result: 'shape',
        }),
        /*#__PURE__*/ React.createElement('feGaussianBlur', {
          stdDeviation: 10.377,
          result: 'effect1_foregroundBlur_21_107',
        }),
      ),
      /*#__PURE__*/ React.createElement(
        'filter',
        {
          id: `bi_slash__j_${id_9}`,
          x: 26.581,
          y: 4.649,
          width: 39.434,
          height: 45.66,
          filterUnits: 'userSpaceOnUse',
          colorInterpolationFilters: 'sRGB',
        },
        /*#__PURE__*/ React.createElement('feFlood', {
          floodOpacity: 0,
          result: 'BackgroundImageFix',
        }),
        /*#__PURE__*/ React.createElement('feBlend', {
          in: 'SourceGraphic',
          in2: 'BackgroundImageFix',
          result: 'shape',
        }),
        /*#__PURE__*/ React.createElement('feGaussianBlur', {
          stdDeviation: 6.226,
          result: 'effect1_foregroundBlur_21_107',
        }),
      ),
      /*#__PURE__*/ React.createElement(
        'filter',
        {
          id: `bi_slash__k_${id_10}`,
          x: 16.204,
          y: -8.219,
          width: 43.48,
          height: 41.509,
          filterUnits: 'userSpaceOnUse',
          colorInterpolationFilters: 'sRGB',
        },
        /*#__PURE__*/ React.createElement('feFlood', {
          floodOpacity: 0,
          result: 'BackgroundImageFix',
        }),
        /*#__PURE__*/ React.createElement('feBlend', {
          in: 'SourceGraphic',
          in2: 'BackgroundImageFix',
          result: 'shape',
        }),
        /*#__PURE__*/ React.createElement('feGaussianBlur', {
          stdDeviation: 5.189,
          result: 'effect1_foregroundBlur_21_107',
        }),
      ),
      /*#__PURE__*/ React.createElement(
        'filter',
        {
          id: `bi_slash__l_${id_11}`,
          x: 10.371,
          y: 6.367,
          width: 36.745,
          height: 35.079,
          filterUnits: 'userSpaceOnUse',
          colorInterpolationFilters: 'sRGB',
        },
        /*#__PURE__*/ React.createElement('feFlood', {
          floodOpacity: 0,
          result: 'BackgroundImageFix',
        }),
        /*#__PURE__*/ React.createElement('feBlend', {
          in: 'SourceGraphic',
          in2: 'BackgroundImageFix',
          result: 'shape',
        }),
        /*#__PURE__*/ React.createElement('feGaussianBlur', {
          stdDeviation: 4.385,
          result: 'effect1_foregroundBlur_21_107',
        }),
      ),
      /*#__PURE__*/ React.createElement(
        'filter',
        {
          id: `bi_slash__m_${id_12}`,
          x: 4.445,
          y: 11.049,
          width: 23.258,
          height: 8.246,
          filterUnits: 'userSpaceOnUse',
          colorInterpolationFilters: 'sRGB',
        },
        /*#__PURE__*/ React.createElement('feFlood', {
          floodOpacity: 0,
          result: 'BackgroundImageFix',
        }),
        /*#__PURE__*/ React.createElement('feColorMatrix', {
          in: 'SourceAlpha',
          values: '0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0',
          result: 'hardAlpha',
        }),
        /*#__PURE__*/ React.createElement('feOffset', {
          dx: 0.074,
          dy: -0.074,
        }),
        /*#__PURE__*/ React.createElement('feGaussianBlur', {
          stdDeviation: 0.185,
        }),
        /*#__PURE__*/ React.createElement('feComposite', {
          in2: 'hardAlpha',
          operator: 'out',
        }),
        /*#__PURE__*/ React.createElement('feColorMatrix', {
          values: '0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.7 0',
        }),
        /*#__PURE__*/ React.createElement('feBlend', {
          in2: 'BackgroundImageFix',
          result: 'effect1_dropShadow_21_107',
        }),
        /*#__PURE__*/ React.createElement('feBlend', {
          in: 'SourceGraphic',
          in2: 'effect1_dropShadow_21_107',
          result: 'shape',
        }),
        /*#__PURE__*/ React.createElement('feColorMatrix', {
          in: 'SourceAlpha',
          values: '0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0',
          result: 'hardAlpha',
        }),
        /*#__PURE__*/ React.createElement('feOffset', {
          dx: -0.148,
          dy: 0.031,
        }),
        /*#__PURE__*/ React.createElement('feGaussianBlur', {
          stdDeviation: 0.214,
        }),
        /*#__PURE__*/ React.createElement('feComposite', {
          in2: 'hardAlpha',
          operator: 'arithmetic',
          k2: -1,
          k3: 1,
        }),
        /*#__PURE__*/ React.createElement('feColorMatrix', {
          values: '0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0',
        }),
        /*#__PURE__*/ React.createElement('feBlend', {
          mode: 'overlay',
          in2: 'shape',
          result: 'effect2_innerShadow_21_107',
        }),
        /*#__PURE__*/ React.createElement('feColorMatrix', {
          in: 'SourceAlpha',
          values: '0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0',
          result: 'hardAlpha',
        }),
        /*#__PURE__*/ React.createElement('feOffset', {
          dx: -0.148,
        }),
        /*#__PURE__*/ React.createElement('feGaussianBlur', {
          stdDeviation: 0.022,
        }),
        /*#__PURE__*/ React.createElement('feComposite', {
          in2: 'hardAlpha',
          operator: 'arithmetic',
          k2: -1,
          k3: 1,
        }),
        /*#__PURE__*/ React.createElement('feColorMatrix', {
          values: '0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0',
        }),
        /*#__PURE__*/ React.createElement('feBlend', {
          mode: 'overlay',
          in2: 'effect2_innerShadow_21_107',
          result: 'effect3_innerShadow_21_107',
        }),
        /*#__PURE__*/ React.createElement('feColorMatrix', {
          in: 'SourceAlpha',
          values: '0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0',
          result: 'hardAlpha',
        }),
        /*#__PURE__*/ React.createElement('feOffset', {
          dx: -0.148,
        }),
        /*#__PURE__*/ React.createElement('feGaussianBlur', {
          stdDeviation: 0.022,
        }),
        /*#__PURE__*/ React.createElement('feComposite', {
          in2: 'hardAlpha',
          operator: 'arithmetic',
          k2: -1,
          k3: 1,
        }),
        /*#__PURE__*/ React.createElement('feColorMatrix', {
          values: '0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0',
        }),
        /*#__PURE__*/ React.createElement('feBlend', {
          mode: 'overlay',
          in2: 'effect3_innerShadow_21_107',
          result: 'effect4_innerShadow_21_107',
        }),
        /*#__PURE__*/ React.createElement('feColorMatrix', {
          in: 'SourceAlpha',
          values: '0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0',
          result: 'hardAlpha',
        }),
        /*#__PURE__*/ React.createElement('feOffset', {
          dx: 0.148,
        }),
        /*#__PURE__*/ React.createElement('feGaussianBlur', {
          stdDeviation: 0.085,
        }),
        /*#__PURE__*/ React.createElement('feComposite', {
          in2: 'hardAlpha',
          operator: 'arithmetic',
          k2: -1,
          k3: 1,
        }),
        /*#__PURE__*/ React.createElement('feColorMatrix', {
          values: '0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.85 0',
        }),
        /*#__PURE__*/ React.createElement('feBlend', {
          in2: 'effect4_innerShadow_21_107',
          result: 'effect5_innerShadow_21_107',
        }),
      ),
      /*#__PURE__*/ React.createElement(
        'filter',
        {
          id: `bi_slash__o_${id_14}`,
          x: 4.741,
          y: 11.492,
          width: 22.519,
          height: 9.274,
          filterUnits: 'userSpaceOnUse',
          colorInterpolationFilters: 'sRGB',
        },
        /*#__PURE__*/ React.createElement('feFlood', {
          floodOpacity: 0,
          result: 'BackgroundImageFix',
        }),
        /*#__PURE__*/ React.createElement('feBlend', {
          in: 'SourceGraphic',
          in2: 'BackgroundImageFix',
          result: 'shape',
        }),
        /*#__PURE__*/ React.createElement('feColorMatrix', {
          in: 'SourceAlpha',
          values: '0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0',
          result: 'hardAlpha',
        }),
        /*#__PURE__*/ React.createElement('feOffset', {
          dy: 1.767,
        }),
        /*#__PURE__*/ React.createElement('feGaussianBlur', {
          stdDeviation: 6.625,
        }),
        /*#__PURE__*/ React.createElement('feComposite', {
          in2: 'hardAlpha',
          operator: 'arithmetic',
          k2: -1,
          k3: 1,
        }),
        /*#__PURE__*/ React.createElement('feColorMatrix', {
          values:
            '0 0 0 0 0.197193 0 0 0 0 0.189101 0 0 0 0 0.160411 0 0 0 1 0',
        }),
        /*#__PURE__*/ React.createElement('feBlend', {
          in2: 'shape',
          result: 'effect1_innerShadow_21_107',
        }),
      ),
      /*#__PURE__*/ React.createElement(
        'filter',
        {
          id: `bi_slash__q_${id_16}`,
          x: 9.899,
          y: -4.5,
          width: 25.723,
          height: 32.537,
          filterUnits: 'userSpaceOnUse',
          colorInterpolationFilters: 'sRGB',
        },
        /*#__PURE__*/ React.createElement('feFlood', {
          floodOpacity: 0,
          result: 'BackgroundImageFix',
        }),
        /*#__PURE__*/ React.createElement('feBlend', {
          in: 'SourceGraphic',
          in2: 'BackgroundImageFix',
          result: 'shape',
        }),
        /*#__PURE__*/ React.createElement('feGaussianBlur', {
          stdDeviation: 1.906,
          result: 'effect1_foregroundBlur_21_107',
        }),
      ),
      /*#__PURE__*/ React.createElement(
        'filter',
        {
          id: `bi_slash__r_${id_17}`,
          x: -6.722,
          y: -2.393,
          width: 41.367,
          height: 35.809,
          filterUnits: 'userSpaceOnUse',
          colorInterpolationFilters: 'sRGB',
        },
        /*#__PURE__*/ React.createElement('feFlood', {
          floodOpacity: 0,
          result: 'BackgroundImageFix',
        }),
        /*#__PURE__*/ React.createElement('feBlend', {
          in: 'SourceGraphic',
          in2: 'BackgroundImageFix',
          result: 'shape',
        }),
        /*#__PURE__*/ React.createElement('feGaussianBlur', {
          stdDeviation: 3.961,
          result: 'effect1_foregroundBlur_21_107',
        }),
      ),
      /*#__PURE__*/ React.createElement(
        'filter',
        {
          id: `bi_slash__s_${id_18}`,
          x: 10.695,
          y: 8.382,
          width: 23.047,
          height: 24.255,
          filterUnits: 'userSpaceOnUse',
          colorInterpolationFilters: 'sRGB',
        },
        /*#__PURE__*/ React.createElement('feFlood', {
          floodOpacity: 0,
          result: 'BackgroundImageFix',
        }),
        /*#__PURE__*/ React.createElement('feBlend', {
          in: 'SourceGraphic',
          in2: 'BackgroundImageFix',
          result: 'shape',
        }),
        /*#__PURE__*/ React.createElement('feGaussianBlur', {
          stdDeviation: 2.498,
          result: 'effect1_foregroundBlur_21_107',
        }),
      ),
      /*#__PURE__*/ React.createElement(
        'filter',
        {
          id: `bi_slash__t_${id_19}`,
          x: 3.116,
          y: 7.415,
          width: 28.439,
          height: 30.006,
          filterUnits: 'userSpaceOnUse',
          colorInterpolationFilters: 'sRGB',
        },
        /*#__PURE__*/ React.createElement('feFlood', {
          floodOpacity: 0,
          result: 'BackgroundImageFix',
        }),
        /*#__PURE__*/ React.createElement('feBlend', {
          in: 'SourceGraphic',
          in2: 'BackgroundImageFix',
          result: 'shape',
        }),
        /*#__PURE__*/ React.createElement('feGaussianBlur', {
          stdDeviation: 4.401,
          result: 'effect1_foregroundBlur_21_107',
        }),
      ),
      /*#__PURE__*/ React.createElement(
        'filter',
        {
          id: `bi_slash__u_${id_20}`,
          x: -7.053,
          y: -6.323,
          width: 22.701,
          height: 31.054,
          filterUnits: 'userSpaceOnUse',
          colorInterpolationFilters: 'sRGB',
        },
        /*#__PURE__*/ React.createElement('feFlood', {
          floodOpacity: 0,
          result: 'BackgroundImageFix',
        }),
        /*#__PURE__*/ React.createElement('feBlend', {
          in: 'SourceGraphic',
          in2: 'BackgroundImageFix',
          result: 'shape',
        }),
        /*#__PURE__*/ React.createElement('feGaussianBlur', {
          stdDeviation: 1.906,
          result: 'effect1_foregroundBlur_21_107',
        }),
      ),
      /*#__PURE__*/ React.createElement(
        'filter',
        {
          id: `bi_slash__v_${id_21}`,
          x: 0.818,
          y: 6.463,
          width: 11.515,
          height: 10.588,
          filterUnits: 'userSpaceOnUse',
          colorInterpolationFilters: 'sRGB',
        },
        /*#__PURE__*/ React.createElement('feFlood', {
          floodOpacity: 0,
          result: 'BackgroundImageFix',
        }),
        /*#__PURE__*/ React.createElement('feBlend', {
          in: 'SourceGraphic',
          in2: 'BackgroundImageFix',
          result: 'shape',
        }),
        /*#__PURE__*/ React.createElement('feGaussianBlur', {
          stdDeviation: 1.842,
          result: 'effect1_foregroundBlur_21_107',
        }),
      ),
      /*#__PURE__*/ React.createElement(
        'filter',
        {
          id: `bi_slash__w_${id_22}`,
          x: 5.462,
          y: 12.539,
          width: 24.686,
          height: 14.201,
          filterUnits: 'userSpaceOnUse',
          colorInterpolationFilters: 'sRGB',
        },
        /*#__PURE__*/ React.createElement('feFlood', {
          floodOpacity: 0,
          result: 'BackgroundImageFix',
        }),
        /*#__PURE__*/ React.createElement('feBlend', {
          in: 'SourceGraphic',
          in2: 'BackgroundImageFix',
          result: 'shape',
        }),
        /*#__PURE__*/ React.createElement('feGaussianBlur', {
          stdDeviation: 2.707,
          result: 'effect1_foregroundBlur_21_107',
        }),
      ),
      /*#__PURE__*/ React.createElement(
        'filter',
        {
          id: `bi_slash__x_${id_23}`,
          x: 4.741,
          y: -1.759,
          width: 22.519,
          height: 20.758,
          filterUnits: 'userSpaceOnUse',
          colorInterpolationFilters: 'sRGB',
        },
        /*#__PURE__*/ React.createElement('feFlood', {
          floodOpacity: 0,
          result: 'BackgroundImageFix',
        }),
        /*#__PURE__*/ React.createElement('feBlend', {
          in: 'SourceGraphic',
          in2: 'BackgroundImageFix',
          result: 'shape',
        }),
        /*#__PURE__*/ React.createElement('feColorMatrix', {
          in: 'SourceAlpha',
          values: '0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0',
          result: 'hardAlpha',
        }),
        /*#__PURE__*/ React.createElement('feOffset', {
          dy: -13.251,
        }),
        /*#__PURE__*/ React.createElement('feGaussianBlur', {
          stdDeviation: 6.625,
        }),
        /*#__PURE__*/ React.createElement('feComposite', {
          in2: 'hardAlpha',
          operator: 'arithmetic',
          k2: -1,
          k3: 1,
        }),
        /*#__PURE__*/ React.createElement('feColorMatrix', {
          values: '0 0 0 0 0.28886 0 0 0 0 0.223105 0 0 0 0 0.145914 0 0 0 1 0',
        }),
        /*#__PURE__*/ React.createElement('feBlend', {
          in2: 'shape',
          result: 'effect1_innerShadow_21_107',
        }),
      ),
      /*#__PURE__*/ React.createElement(
        'filter',
        {
          id: `bi_slash__B_${id_27}`,
          x: 6.34,
          y: 0.007,
          width: 33.635,
          height: 24.089,
          filterUnits: 'userSpaceOnUse',
          colorInterpolationFilters: 'sRGB',
        },
        /*#__PURE__*/ React.createElement('feFlood', {
          floodOpacity: 0,
          result: 'BackgroundImageFix',
        }),
        /*#__PURE__*/ React.createElement('feBlend', {
          in: 'SourceGraphic',
          in2: 'BackgroundImageFix',
          result: 'shape',
        }),
        /*#__PURE__*/ React.createElement('feGaussianBlur', {
          stdDeviation: 1.626,
          result: 'effect1_foregroundBlur_21_107',
        }),
      ),
      /*#__PURE__*/ React.createElement(
        'filter',
        {
          id: `bi_slash__C_${id_28}`,
          x: -6.533,
          y: 2.691,
          width: 33.4,
          height: 25.054,
          filterUnits: 'userSpaceOnUse',
          colorInterpolationFilters: 'sRGB',
        },
        /*#__PURE__*/ React.createElement('feFlood', {
          floodOpacity: 0,
          result: 'BackgroundImageFix',
        }),
        /*#__PURE__*/ React.createElement('feBlend', {
          in: 'SourceGraphic',
          in2: 'BackgroundImageFix',
          result: 'shape',
        }),
        /*#__PURE__*/ React.createElement('feGaussianBlur', {
          stdDeviation: 2.707,
          result: 'effect1_foregroundBlur_21_107',
        }),
      ),
      /*#__PURE__*/ React.createElement(
        'filter',
        {
          id: `bi_slash__F_${id_31}`,
          x: -8.117,
          y: 1.693,
          width: 27.504,
          height: 23.663,
          filterUnits: 'userSpaceOnUse',
          colorInterpolationFilters: 'sRGB',
        },
        /*#__PURE__*/ React.createElement('feFlood', {
          floodOpacity: 0,
          result: 'BackgroundImageFix',
        }),
        /*#__PURE__*/ React.createElement('feBlend', {
          in: 'SourceGraphic',
          in2: 'BackgroundImageFix',
          result: 'shape',
        }),
        /*#__PURE__*/ React.createElement('feGaussianBlur', {
          stdDeviation: 3.104,
          result: 'effect1_foregroundBlur_21_107',
        }),
      ),
      /*#__PURE__*/ React.createElement(
        'filter',
        {
          id: `bi_slash__G_${id_32}`,
          x: 14.9,
          y: 11.182,
          width: 16.859,
          height: 15.71,
          filterUnits: 'userSpaceOnUse',
          colorInterpolationFilters: 'sRGB',
        },
        /*#__PURE__*/ React.createElement('feFlood', {
          floodOpacity: 0,
          result: 'BackgroundImageFix',
        }),
        /*#__PURE__*/ React.createElement('feBlend', {
          in: 'SourceGraphic',
          in2: 'BackgroundImageFix',
          result: 'shape',
        }),
        /*#__PURE__*/ React.createElement('feGaussianBlur', {
          stdDeviation: 1.256,
          result: 'effect1_foregroundBlur_21_107',
        }),
      ),
      /*#__PURE__*/ React.createElement(
        'filter',
        {
          id: `bi_slash__H_${id_33}`,
          x: 4.667,
          y: 11.492,
          width: 22.592,
          height: 7.507,
          filterUnits: 'userSpaceOnUse',
          colorInterpolationFilters: 'sRGB',
        },
        /*#__PURE__*/ React.createElement('feFlood', {
          floodOpacity: 0,
          result: 'BackgroundImageFix',
        }),
        /*#__PURE__*/ React.createElement('feBlend', {
          in: 'SourceGraphic',
          in2: 'BackgroundImageFix',
          result: 'shape',
        }),
        /*#__PURE__*/ React.createElement('feColorMatrix', {
          in: 'SourceAlpha',
          values: '0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0',
          result: 'hardAlpha',
        }),
        /*#__PURE__*/ React.createElement('feOffset', {
          dx: -0.074,
        }),
        /*#__PURE__*/ React.createElement('feGaussianBlur', {
          stdDeviation: 0.081,
        }),
        /*#__PURE__*/ React.createElement('feComposite', {
          in2: 'hardAlpha',
          operator: 'arithmetic',
          k2: -1,
          k3: 1,
        }),
        /*#__PURE__*/ React.createElement('feColorMatrix', {
          values: '0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0',
        }),
        /*#__PURE__*/ React.createElement('feBlend', {
          in2: 'shape',
          result: 'effect1_innerShadow_21_107',
        }),
      ),
      /*#__PURE__*/ React.createElement(
        'linearGradient',
        {
          id: `bi_slash__p_${id_15}`,
          x1: 16,
          y1: 11.492,
          x2: 16,
          y2: 18.999,
          gradientUnits: 'userSpaceOnUse',
        },
        /*#__PURE__*/ React.createElement('stop', {
          stopColor: '#F8E1C7',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 1,
          stopColor: '#CBB890',
        }),
      ),
      /*#__PURE__*/ React.createElement(
        'linearGradient',
        {
          id: `bi_slash__y_${id_24}`,
          x1: 16,
          y1: 11.492,
          x2: 16,
          y2: 18.999,
          gradientUnits: 'userSpaceOnUse',
        },
        /*#__PURE__*/ React.createElement('stop', {
          stopColor: '#888580',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 1,
          stopColor: '#7D7D7D',
        }),
      ),
      /*#__PURE__*/ React.createElement(
        'pattern',
        {
          id: `bi_slash__z_${id_26}`,
          patternContentUnits: 'objectBoundingBox',
          width: 1,
          height: 1,
        },
        /*#__PURE__*/ React.createElement('use', {
          xlinkHref: `#bi_slash__I_${id_34}`,
          transform: 'scale(.00098)',
        }),
      ),
      /*#__PURE__*/ React.createElement(
        'pattern',
        {
          id: `bi_slash__D_${id_30}`,
          patternContentUnits: 'objectBoundingBox',
          width: 1,
          height: 1,
        },
        /*#__PURE__*/ React.createElement('use', {
          xlinkHref: `#bi_slash__J_${id_35}`,
          transform: 'scale(.00098)',
        }),
      ),
      /*#__PURE__*/ React.createElement('image', {
        id: `bi_slash__I_${id_34}`,
        'data-name': 'image0_2016_202.png',
        width: 1024,
        height: 1024,
        preserveAspectRatio: 'none',
        xlinkHref:
          'data:image/png;base64,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',
      }),
      /*#__PURE__*/ React.createElement('image', {
        id: `bi_slash__J_${id_35}`,
        'data-name': 'image1_2016_202.png',
        width: 1024,
        height: 1024,
        preserveAspectRatio: 'none',
        xlinkHref:
          'data:image/png;base64,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',
      }),
    ),
  );
});
slashSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
  xmlnsXlink: 'http://www.w3.org/1999/xlink',
};
export var slash = {
  category: 'brand',
  colorable: false,
  name: 'slash',
  svg: slashSvg,
};
